<div [formGroup]="form">
  <h3 class=contact-form-title>Contact</h3>
  <mat-accordion [multi]="true">
    <mat-expansion-panel  [expanded]="checkDiffs('name_form', diffs)">
      <mat-expansion-panel-header>
        @if (name) {
          <mat-panel-title >
            <span class="header-name"><mat-icon>person</mat-icon></span> &nbsp; {{ name }}
          </mat-panel-title>
        } @else {
          <span class="header-name"><mat-icon>person</mat-icon></span> &nbsp; <em class="empty-title">No name listed</em>
        }
      </mat-expansion-panel-header>
      <name-form formControlName="names"></name-form>

        </mat-expansion-panel>

        <mat-expansion-panel [expanded]="checkDiffs('email_form', diffs)">
          <mat-expansion-panel-header>
            @if (email) {
              <mat-panel-title >
                <span class="header-name"><mat-icon>email</mat-icon></span> &nbsp; {{ email }}
              </mat-panel-title>
            } @else {
              <span class="header-name"><mat-icon>email</mat-icon></span> &nbsp; <em class="empty-title">No email listed</em>
            }
          </mat-expansion-panel-header>
          <email-form formControlName="email"></email-form>
        </mat-expansion-panel>

        <mat-expansion-panel [expanded]="checkDiffs('address_form', diffs)">
          <mat-expansion-panel-header>
            @if (existingAddress) {
              <mat-panel-title >
                <span class="header-name"><mat-icon>cottage</mat-icon></span> &nbsp; {{ existingAddress }}
              </mat-panel-title>
            } @else {
              <span class="header-name"><mat-icon>cottage</mat-icon></span> &nbsp; <em class="empty-title">No address listed</em>
            }
          </mat-expansion-panel-header>
          <address-form formControlName="address"></address-form>
        </mat-expansion-panel>

        <mat-expansion-panel [expanded]="checkDiffs('phone_form', diffs)">
          <mat-expansion-panel-header>
            @if (existingPhoneNumber) {
              <mat-panel-title >
                <span class="header-name"><mat-icon>phone</mat-icon></span> &nbsp; {{ existingPhoneNumber }}
              </mat-panel-title>
            } @else {
              <span class="header-name"><mat-icon>phone</mat-icon></span> &nbsp; <em class="empty-title">No phone listed</em>
            }
          </mat-expansion-panel-header>
          <phone-form formControlName="phone" ></phone-form>
        </mat-expansion-panel>
        <mat-expansion-panel [expanded]="checkDiffs('social_form', diffs)">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <span class="header-name"><mat-icon>chat</mat-icon></span>  &nbsp; Social Media
            </mat-panel-title>
          </mat-expansion-panel-header>
          <social-form formControlName="socialMedia" ></social-form>
        </mat-expansion-panel>
      </mat-accordion>
